<template>
  <div
    class="ai-visibility-question-item"
    :class="{ 'ai-visibility-question-item--editable': editable }"
  >
    <label class="ai-visibility-question-item__label">
      <input
        class="ai-visibility-question-item__checkbox"
        type="checkbox"
        :checked="selected"
        @change="$emit('toggle')"
      />
      <span>{{ question.text }}</span>
    </label>

    <div v-if="editable || deletable" class="ai-visibility-question-item__actions">
      <button
        v-if="editable"
        type="button"
        title="Edit question"
        @click="$emit('edit')"
      >
        <i class="material-icons-outlined">edit</i>
      </button>
      <button
        v-if="deletable"
        type="button"
        title="Delete question"
        @click="$emit('delete')"
      >
        <i class="mdi mdi-trash-can-outline"></i>
      </button>
    </div>
  </div>
</template>

<script>
export default {
  name: 'QuestionListItem',
  props: {
    question: {
      type: Object,
      required: true,
    },
    selected: {
      type: Boolean,
      default: false,
    },
    editable: {
      type: Boolean,
      default: false,
    },
    deletable: {
      type: Boolean,
      default: false,
    },
  },
}
</script>

<style lang="scss" scoped>

.ai-visibility-question-item {
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 8px;
  border-radius: 5px;

  &:hover {
    background-color: var(--v-gray12Color-base);
  }

  &:hover .ai-visibility-question-item__actions {
    opacity: 1;
  }
}

.ai-visibility-question-item__label {
  display: flex;
  flex: 1;
  align-items: center;
  gap: 10px;
  color: var(--v-mainColor-base);
  cursor: pointer;
  font-size: 16px;
  line-height: 1.5;
  margin: 0;
  min-width: 0;

  span {
    min-width: 0;
    overflow-wrap: anywhere;
  }
}

.ai-visibility-question-item--editable .ai-visibility-question-item__label span:hover {
  text-decoration: underline;
}

.ai-visibility-question-item__checkbox {
  position: relative;
  width: 20px;
  height: 20px;
  appearance: none;
  -webkit-appearance: none;
  border: 1px solid var(--v-darkGrayColor-base);
  border-radius: 4px;
  background: var(--v-cardBg-base);
  cursor: pointer;
  flex: 0 0 20px;
  outline-color: var(--v-darkGrayColor-base);

  &:checked::after {
    position: absolute;
    left: 5px;
    top: 1px;
    width: 7px;
    height: 12px;
    border: solid var(--v-green7Color-base);
    border-width: 0 2px 2px 0;
    content: '';
    transform: rotate(45deg);
  }
}

.ai-visibility-question-item__actions {
  display: flex;
  gap: 6px;
  opacity: 0.75;

  button {
    display: flex;
    width: 24px;
    height: 24px;
    align-items: center;
    justify-content: center;
    border: 0;
    background: transparent;
    color: var(--v-gray2Color-base);
    cursor: pointer;
    padding: 0;
  }

  i {
    font-size: 20px;
  }
}
</style>
